import React from "react";

import { Routes, Route, Navigate } from "react-router-dom";

import { Box } from "@mui/material";

import AboutMe from "../about-me/AboutMe";
import Articles from "../articles/Articles";
import Projects from "../projects/Projects";
import NotFound from "../not-found/NotFound";

import { ROUTES } from "../common/common.constants";

import "./content.scss";

const Content = () => {
    return (
        <Box className="fullSpace flexContainer flexCol p-2">
            <Routes>
                <Route
                    exact
                    path={ROUTES.NONE}
                    element={<Navigate to={ROUTES.ABOUT_ME} />}
                />
                <Route
                    exact
                    path={ROUTES.ROOT}
                    element={<Navigate to={ROUTES.ABOUT_ME} />}
                />
                <Route exact path={ROUTES.ABOUT_ME} element={<AboutMe />} />
                <Route exact path={ROUTES.ARTICLES} element={<Articles />} />
                <Route exact path={ROUTES.PROJECTS} element={<Projects />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Box>
    );
};

export default Content;
